import { makeAutoObservable, runInAction } from "mobx";
import apiHandler from "../handlers/ApiHandler";

class OrganizationStore {
  organizations = [];
  isLoading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchOrganizations() {
    this.isLoading = true;
    this.error = null;
    try {
      const response = await apiHandler.get("/api/organizations");
      runInAction(() => {
        this.organizations = Array.isArray(response.data)
          ? response.data
          : response;
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error("Error fetching organizations:", error);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async createOrganization(newOrganization) {
    try {
      const response = await apiHandler.post(
        "/api/organizations",
        newOrganization
      );
      runInAction(() => {
        this.organizations.push(response.data || response);
      });
      return response;
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error("Error creating organization:", error);
      throw error;
    }
  }

  async updateOrganization(id, updatedData) {
    try {
      const response = await apiHandler.put(
        `/api/organizations/${id}`,
        updatedData
      );
      runInAction(() => {
        const index = this.organizations.findIndex((org) => org.id === id);
        if (index !== -1) {
          this.organizations[index] = response.data || response;
        }
      });
      return response;
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error(`Error updating organization with ID ${id}:`, error);
      throw error;
    }
  }

  async deleteOrganization(id) {
    try {
      await apiHandler.delete(`/api/organizations/${id}`);
      runInAction(() => {
        this.organizations = this.organizations.filter((org) => org.id !== id);
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error(`Error deleting organization with ID ${id}:`, error);
      throw error;
    }
  }

  clearError() {
    this.error = null;
  }
}

const organizationStore = new OrganizationStore();
export default organizationStore;
